import { useCallback } from "react";
import { useResolvedNavigationShortcuts } from "../useResolvedNavigationShortcuts";

/**
 * Looks up the enabled navigation shortcut for a row's path, as the hotkey
 * string `SideNavItem`'s `shortcut` takes (e.g. `g>h` for `/chart-of-accounts`).
 */
export const useNavigationShortcutKeys = () => {
    const shortcuts = useResolvedNavigationShortcuts();

    return useCallback(
        (path: string) =>
            shortcuts.find(
                (shortcut) => shortcut.isEnabled && shortcut.path === path,
            )?.keys,
        [shortcuts],
    );
};
